import { render, staticRenderFns } from "./CardDetailRate.vue?vue&type=template&id=5f6400d2&scoped=true&"
import script from "./CardDetailRate.vue?vue&type=script&lang=js&"
export * from "./CardDetailRate.vue?vue&type=script&lang=js&"
import style0 from "./CardDetailRate.vue?vue&type=style&index=0&id=5f6400d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6400d2",
  null
  
)

export default component.exports